import { yupResolver } from "@hookform/resolvers/yup";
import { IonContent } from "@ionic/react";
import { Editor } from "@tiptap/react";
import { FormEvent, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import * as yup from "yup";

import FormButtons from "@components/fields/FormButtons";
import Input from "@components/fields/Input";
import Form from "@components/forms/Form";

type LinkFormProps = {
  dismiss: () => void;
  editor: Editor;
  isOpen: boolean;
};

const RichTextareaHyperlinkForm = ({ dismiss, editor, isOpen }: LinkFormProps) => {
  const intl = useIntl();

  type FormData = {
    linkUrl: string;
  };

  const defaultValues: FormData = {
    linkUrl: ""
  };

  const schema: yup.ObjectSchema<FormData> = yup
    .object()
    .shape({
      linkUrl: yup
        .string()
        .url(intl.formatMessage({ id: "errors.richTextArea.linkUrl.formatting" }))
        .required(intl.formatMessage({ id: "errors.richTextArea.linkUrl.blank" }))
    })
    .required();

  const form = useForm<FormData>({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema)
  });

  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();

      editor
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: form.getValues().linkUrl, target: "_blank" })
        .run();

      dismiss();
      editor.commands.focus();
    },
    [dismiss, editor, form]
  );

  return (
    <IonContent className="ion-padding">
      <Form hookForm={form} onSubmit={handleSubmit}>
        <Input<FormData>
          autofocus={isOpen}
          error={form.formState.errors.linkUrl}
          label={intl.formatMessage({ id: "forms.richTextArea.linkUrlLabel" })}
          register={form.register("linkUrl")}
          required
        />
        <FormButtons hookForm={form} onCancel={dismiss} saveKey="dictionary.add" />
      </Form>
    </IonContent>
  );
};

export default RichTextareaHyperlinkForm;
